import { useAProgress } from 'hooks/useAProgress'
import { refetchFunc } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { SharedModalContent, SharedModalFooter, SharedModalTitle } from 'views/components/SharedModal'
import ASharedModal from 'views/components/SharedModal/ASharedModal'

type Props = {
  sampleId: number
  refetch: refetchFunc
  onClose: () => void
}

export const ConfirmArchive: FC<Props> = ({ sampleId, refetch, onClose }) => {
  const { t } = useTranslation('samples')

  const [removeProgress, removeSample] = useAProgress(() => apiClient.delete(endpoints.samples(sampleId)), {
    eventName: 'removeSample',
    analyticsPayload: {
      id: sampleId.toString(),
    },
    onSuccess: () => refetch(),
  })

  return (
    <ASharedModal onClose={onClose} size="small" id="archive_modal">
      <SharedModalTitle>{t('archiveSample')}</SharedModalTitle>
      <SharedModalContent>{t('areYouSureToArchiveSample')}</SharedModalContent>
      <SharedModalFooter>
        <AButton
          progress={removeProgress}
          onClick={async () => {
            await removeSample()
            onClose()
          }}
          color="primary"
          size="big"
          id="save"
        >
          {t('common:archive')}
        </AButton>

        <AButton id="close" color="secondary" size="big" onClick={onClose}>
          {t('common:canceling')}
        </AButton>
      </SharedModalFooter>
    </ASharedModal>
  )
}
